import React from 'react';
import '../../styles/CustomTitle.css';

const CustomTitle = ({ titleText, deviceType, deviceId, className }) => {
  return (
    <div className="custom-title_container">
      <div className={`custom-title_text ${className || ''}`}>
        {titleText} {deviceType} {deviceId ? '№' : ''} {deviceId}
      </div>
    </div>
  );
};

export default CustomTitle;
